import { useWeb3React } from '@web3-react/core'
import { GawdsContractFactory } from 'web/lib/contract'
import { Cult } from 'web/lib/gawd'
import useSWR from 'swr'
import { CacheKey } from 'web/lib/cache-keys'
import { CultBinder } from 'web/types/ethers-contracts'

const useBoundCult = (): Cult => {
  const { account, active } = useWeb3React()
  const cultsContract = GawdsContractFactory.get("CultBinder") as CultBinder

  const { data } = useSWR(CacheKey.currentCult(account), async () => {
    if (!active) return
    const cultId = await cultsContract.cultForOwner(account)
    return Cult.getById(cultId)
  }, {
    refreshInterval:  1000 * 60 * 60, // 60 minutes
  })

  return data || null
}

export default useBoundCult;